import React from 'react';
import { BuyProcessState } from '../../../../buy-process-form-types';
import { SummaryLabelledInfo } from '../labelled-info';
import { useSelectConfiguration } from '../../../../../app/use-app';

interface SummaryCompanyProps {
  companyDetails: BuyProcessState['companyDetails'];
}

export const SummaryCompany = ({ companyDetails }: SummaryCompanyProps) => {
  const {
    desiredCompanyName,
    firstAlternativeCompanyName,
    secondAlternativeCompanyName,
    address,
    co,
    taxHelp,
    nameReview,
    municipality,
    businessDescription,
    city,
    postalCode,
  } = companyDetails;

  const { fees } = useSelectConfiguration();

  const getNameReviewLabel = () => `Namngranskning (+${fees.nameReviewFee}kr)`;
  const getTaxHelpLabel = () =>
    `Hjälp med ansökan om f-skatt, moms och arbetsgivare (+${fees.taxHelpFee}kr)`;

  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Önskat företagsnamn">
        {desiredCompanyName}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Alternativt företagsnamn 1">
        {firstAlternativeCompanyName}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Alternativt företagsnamn 2">
        {secondAlternativeCompanyName}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Utdelningsadress">
        {co ? `c/o ${co}, ${address}` : address}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Postnummer">{postalCode}</SummaryLabelledInfo>

      <SummaryLabelledInfo label="Ort">{city}</SummaryLabelledInfo>

      <SummaryLabelledInfo label="Styrelsens Säte (kommun)">
        {municipality?.value}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Verksamhetsbeskrivning">
        {businessDescription}
      </SummaryLabelledInfo>

      {nameReview && (
        <SummaryLabelledInfo label={getNameReviewLabel()}>
          Vald
        </SummaryLabelledInfo>
      )}

      {taxHelp && (
        <SummaryLabelledInfo label={getTaxHelpLabel()}>
          Vald
        </SummaryLabelledInfo>
      )}
    </React.Fragment>
  );
};
